
import React, { useEffect, useState } from "react";
import axios from "axios";
import "../Styles/Gallery.css";

function VideoGallery() {
  const [videos, setVideos] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  const videosPerPage = 6;

  useEffect(() => {
    axios
      .get("/api/gallery/videos")
      .then((res) => {
        setVideos(res.data);
      })
      .catch((err) => {
        console.error("Video fetch error:", err);
      });
  }, []);

  const startIndex = currentPage * videosPerPage;

  const currentVideos = videos.slice(
    startIndex,
    startIndex + videosPerPage
  );

  const hasNextPage =
    startIndex + videosPerPage < videos.length;

  const hasPreviousPage = currentPage > 0;

  const handleNext = () => {
    if (hasNextPage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (hasPreviousPage) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="gallery-page">
      <section className="video-section">
        <div className="container">
          {videos.length === 0 ? (
            <div className="video-empty">
              <p>No videos available.</p>
            </div>
          ) : (
            <div className="video-gallery-row">
              {/* LEFT ARROW */}
              <button
                className="video-gallery-arrow"
                onClick={handlePrevious}
                disabled={!hasPreviousPage}
              >
                &lt;
              </button>

              {/* VIDEO CONTAINERS */}
              <div className="video-gallery-items">
                {currentVideos.map((video) => (
                  <div
                    className="video-gallery-item"
                    key={video.id}
                  >
                    <div className="video-box">
                      <video
                        src={video.fileUrl.startsWith("http")
                          ? video.fileUrl
                          : video.fileUrl.startsWith("/")
                            ? video.fileUrl
                            : `/${video.fileUrl}`}
                        className="temple-video"
                        controls
                      />

                      <h5>{video.title}</h5>

                      {video.description && (
                        <p>{video.description}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* RIGHT ARROW */}
              <button
                className="video-gallery-arrow"
                onClick={handleNext}
                disabled={!hasNextPage}
              >
                &gt;
              </button>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default VideoGallery;
